import { CurrencyInput,parseCurrency } from 'vue-currency-input';
import { validationMixin } from 'vuelidate';
import { required, requiredIf } from 'vuelidate/lib/validators';
export default {
    components: { CurrencyInput },
    validations: {
        val : {
            required : requiredIf(function (model) {
                console.warn('required', this.required);
                if (this.required) {
                    return true;
                } else {
                    return false;
                }
            }),
        },
    },
    props: {
        label       :  {
            type    : String,
            default : "MoneyField"
        },
        hint       :  {
            type    : String,
            default : ""
        },
        required       :  {
            type    : Boolean,
            default : false
        },
        disabled       :  {
            type    : Boolean,
            default : false
        },
        value       :  {
            type    : null,
            default : null
        },
        persistentHint  :  {
            type    : Boolean,
            default : false
        },
    },
    data() {
        return {
            val                         : null,
            locale                      : 'gsw-CH',
            // currency                 : 'CHF',
            currencySymbol              : ' CHF ',
            labelPosition               : 'prefix',
            hideNegligibleDecimalDigits : false,
            hideCurrencySymbol          : false,
            hideGroupingSymbol          : false,
            decimalLength               : 2, //round to 2 decimal
        };
    },
    computed: {
        numberValue () {
            console.info('numberfield');
            return parseCurrency(this.val, this.locale, this.currency);
            // return parseCurrency(formattedValue);
        },
        currency () {
            return { [this.labelPosition]: this.currencySymbol }
        },
        distractionFree () {
            return {
                hideNegligibleDecimalDigits : this.hideNegligibleDecimalDigits,
                hideCurrencySymbol          : this.hideCurrencySymbol,
                hideGroupingSymbol          : this.hideGroupingSymbol
            }
        },
        retValue() {
            if(this.val){
                return parseFloat(this.val).toFixed(2);
            } else {
                return ""
            }
        },
        valErrors () {
            const errors = [];
            if (!this.$v.val.$dirty) {
                return errors;
            }
            if(!this.$v.val.required) {
                errors.push('val is required.');
            }
            return errors;
        },

    },
    methods : {
        validate() {
            console.info('validate money field');
            this.$v.val.$touch();
            if (this.$v.val.$anyError) {
                return false;
            } else {
                return true;
            }

        },
        reset() {
            console.info('reset money field');
            this.val = null;
        },
        getValue() {
            return this.val;
        },
        setValue(value) {
            this.val = value;
            return;
        },
    }
};
